<template>
    <div :class="progressClass">
        <div class="ref">
            <div class="opt-step" :key="index" v-for="(label, index) in parsedSteps">
                <span class="icon" :data-step="index + 1"></span>
                <span class="text" v-html="label"></span>
            </div>
        </div>
        <div class="actual">
            <div class="opt-step" :class="stepClass(index)" :key="index" v-for="(label, index) in parsedSteps">
                <span class="icon" :data-step="index + 1"></span>
                <span class="text" v-html="label"></span>
            </div>
        </div>
    </div>
</template>

<script setup>
    const prefix = inject("prefix");

    const props = defineProps({
        current: { default: 1, type: Number },
        steps: { required: true, type: Array }
    });

    const parsedSteps = computed(() => {
        return props.steps.map((step) => step.replace(/\n/g, "<br>"));
    });

    const progressClass = computed(() => {
        let width = Math.min((props.current - 1) * 100 / (props.steps.length - 1), 100);

        return `
            rel
            {visibility:hidden;static!;transform:none!}_.ref_.opt-step
            {pl:8;pr:24;bg:white;color:gray03;inline-flex;ai:center;rel;bg:white}_.opt-step
            {pl:8;pr:8;flex-direction:column}_.opt-step@<sm
            {color:primary}_.opt-step.current
            {color:primary}_.opt-step.complete
            {w:32;min-w:32;h:32;flex;r:100%;border:1|solid|gray03;ai:center;jc:center}_.opt-step_.icon
            {content:attr(data-step)}_.opt-step_.icon::before
            {content:"";inline-block;w:16;h:16;bg:url(${prefix}image/icon_checked.svg)}_.opt-step.complete_.icon::before
            {bg:primary;color:white;border:1|solid|primary}_.opt-step.current_.icon
            {bg:primary;color:white;border:1|solid|primary}_.opt-step.complete_.icon
            {ml:8;f:14;font-weight:700;white-space:nowrap}_.opt-step_.text
            {ml:0;t:center;mt:8}_.opt-step_.text@<sm
            {d:none}_.opt-step_.text>br@sm
            {z:1;abs!;top:50%;transform:translateY(-50%)}_.opt-step
            {pl:0}_.opt-step:first-child
            {pr:0}_.opt-step:last-child
            {abs;content:"";h:3;bg:#EBEBEB;w:full;top:50%;left:0;transform:translateY(-50%);z:0}::before
            {abs;content:"";h:3;bg:#B5CDED;w:0;top:50%;left:0;transform:translateY(-50%);z:0}::after
            {w:${width}%!}::after
        `;
    });

    const stepClass = (index) => {
        const width = Math.min(index * 100 / (props.steps.length - 1), 100);
        const classNames = [`left:${width}%!`, `transform:translateX(-${width}%)|translateY(-50%)!`];

        if ((props.current - 1) > index) {
            classNames.push("complete");
        } else if ((props.current - 1) === index) {
            classNames.push("current");
        }

        return classNames;
    };
</script>
